/** @import {GetServerSideAuthProps} from './utils' */

import { HTTPMethods } from '@synqly/sdk/core'
import { getOrganizationAuth, notFound, badRequest } from './utils'
import { withSecret } from '../server-side-secrets'
import { callAPI } from '@synqly/sdk/server'

export { SingleSignOnPage as Page, getServerSideProps, routeParams }

const routeParams = '[organizationId]/[ssoId]'

/** @type {GetServerSideAuthProps} */
async function getServerSideProps(context, authContext) {
  const [organizationId, ssoId] = authContext.params
  const authConfig = await getOrganizationAuth(organizationId)

  if (!authConfig) {
    return notFound(context, `Unknown organization ${organizationId}`)
  }

  const idp = authConfig.ssoProviders[ssoId]
  if (!idp) {
    return notFound(context, `Unknown identity provider ${ssoId}`)
  }

  const orgId = authConfig.organization.id
  const { NEXT_PUBLIC_APP_URL } = process.env
  const ingressURL = new URL(NEXT_PUBLIC_APP_URL)
  const redirectURL = new URL(idp.redirect_uri ?? '/auth/callback', ingressURL)

  if (redirectURL.origin !== ingressURL.origin) {
    return badRequest(context, `invalid redirect_uri: ${redirectURL}`)
  }

  const { callbackUrl } = context.query
  if (callbackUrl) {
    redirectURL.searchParams.set('callbackUrl', String(callbackUrl))
  }

  const { result, error, response } = await callAPI(
    `/v1/auth/logon/${orgId}/${ssoId}`,
    {
      method: HTTPMethods.POST,
      body: {
        redirect_uri: redirectURL,
      },
    },
  )

  if (error) {
    return badRequest(context, error?.message)
  }

  await withSecret(context, 'synqly-sso-state', {
    fallback: async () => ({
      state: result.state,
      organizationId: authConfig.organization.id,
      type: idp.type,
      redirectURL,
      cookie: response.headers.getSetCookie(),
    }),
    validate: async (value) => value,
    sameSite: 'lax',
  })

  return {
    redirect: {
      destination: result.authorization_url,
      permanent: false,
    },
  }
}

function SingleSignOnPage() {
  return null
}
